import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Flex,
  Icon,
  Button,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import ReactMarkdown from 'react-markdown';
import { MdArrowForward } from 'react-icons/md';

export type FaqQuestionType = { title: string; answer: string };

const FaqQuestion = ({ answer, title }: FaqQuestionType) => {
  const { t } = useTranslation(`faq`);
  const [selectedOption, setSelectedOption] =
    useState<'positive' | 'negative' | undefined>();
  return (
    <AccordionItem>
      {({ isExpanded }) => (
        <>
          <AccordionButton
            py="8"
            border="none"
            textAlign="start"
            ps="0"
            fontSize={[`md`, null, `lg`, `xl`]}
            fontWeight={isExpanded ? `bold` : `medium`}
            color={isExpanded ? `#48494c` : `#6f7070`}
          >
            {title}
          </AccordionButton>
          <AccordionPanel pt="6" fontSize={[`md`, null, null, `lg`]} pb={9}>
            <ReactMarkdown>{answer}</ReactMarkdown>
            <Flex
              mt={10}
              direction={[`column`, null, `row`]}
              justify="start"
              align={[`start`, null, `center`]}
            >
              <Flex
                fontSize="sm"
                fontWeight="semibold"
                justify="start"
                align="center"
              >
                <Icon me="4" as={MdArrowForward} /> {t(`helpful.title`)}
              </Flex>
              <Flex mt={[3, null, 0]} ms="8" justify="start" align="center">
                <Button
                  fontWeight="bold"
                  textDecoration="underline"
                  variant="link"
                  isDisabled={selectedOption === `negative`}
                  colorScheme="gray"
                  onClick={() => setSelectedOption(`positive`)}
                >
                  {t(`helpful.button_positive`)}
                </Button>
                <Button
                  fontWeight="bold"
                  textDecoration="underline"
                  ms="8"
                  _focus={{ opacity: 0.75 }}
                  variant="link"
                  colorScheme="gray"
                  isDisabled={selectedOption === `positive`}
                  onClick={() => setSelectedOption(`negative`)}
                >
                  {t(`helpful.button_negative`)}
                </Button>
              </Flex>
            </Flex>
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
};

export default FaqQuestion;
